export default class Popup {
    constructor(selector = '[data-dialog]') {
        this.rootHtml = document.querySelector('html');
        this.dialog = document.getElementById('dialog'); // for now we only need one popup
        this.toggleClass = 'popup-open';
        if (!this.dialog) return; // bail if no popup

        // Setup links, if any
        const popup_links = document.querySelectorAll(selector);
        if (!popup_links) return; // bail if no links
        popup_links.forEach(el => {
            el.addEventListener('click', (e) => this.openPopup(e, this));
        });

        // Close popup on click outside or escape key
        document.addEventListener('mouseup', (e) => this.watchMouseUp(e, this));
        document.addEventListener('keydown', (e) => this.watchKeyPress(e, this));

        // Setup the close button
        this.dialog.querySelector('.btn-close').addEventListener('click', (e) => this.closePopup(e, this));
    }

    // open the dialog
    openPopup(event) {
        event.preventDefault();
        event.stopPropagation();

        if (!this.dialog.open) {
            this.rootHtml.classList.add(this.toggleClass);

            var id = event.target.getAttribute('href').replace('#','');
            var content = document.getElementById(id).cloneNode(true);
            var content_id = id+'-popup';

            content.setAttribute('id', content_id); // no duplicated id please
            content.classList.remove('sr-only'); // un-hide

            var popup_container = this.dialog.querySelector('.popup-content');
            popup_container.textContent = "";
            popup_container.append(content);

            this.dialog.removeAttribute('aria-hidden');
            this.dialog.showModal();

            const evnt = new CustomEvent('popup-opened', {
                'detail': {'popup_id': content_id}
            });
            window.dispatchEvent(evnt);
        }
    }

    // close the dialog
    closePopup(event) {
        event.preventDefault();
        event.stopPropagation();

        if (this.dialog.open) {
            this.rootHtml.classList.remove(this.toggleClass);
            this.dialog.setAttribute('aria-hidden', true);
            this.dialog.close();

            const evnt = new Event('popup-closed');
            window.dispatchEvent(evnt);
            this.dialog.querySelector('.popup-content').empty();
        }
    }


    // Dialogs work in a weird way: when open, they kinda become the whole document
    // So we watch for clicks in/out of an inner div.
    watchMouseUp(event) {
        if (this.rootHtml.classList.contains(this.toggleClass)) {
            let dialog = document.querySelector('dialog[open]');
            let inner = dialog.querySelector('.popup');

            if (!inner.contains(event.target)) {
                dialog.close();
                this.rootHtml.classList.remove(this.toggleClass);
            }
        }
    }

    watchKeyPress(event) {
        if (this.rootHtml.classList.contains(this.toggleClass)) {
            if (event.key == 'Escape') {
                let dialog = document.querySelector('dialog[open]');
                dialog.close();
                this.rootHtml.classList.remove(this.toggleClass);
            }
        }
    }
}